import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import { authGuard, blockbusterGuard, surelockCreateGuard, surelockGuard } from '../auth/authGuard';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'Portal',
    },
    component: Home,
  },
  {
    path: '/blockbuster',
    name: 'Blockbuster',
    meta: {
      title: 'Portal - Blockbuster',
    },
    beforeEnter: blockbusterGuard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "blockbuster" */ '../views/Blockbuster.vue'),
  },
  {
    path: '/surelock',
    name: 'SureLock',
    meta: {
      title: 'Portal - SureLock',
    },
    beforeEnter: surelockGuard,
    component: () =>
      import(/* webpackChunkName: "surelock" */ '../views/SureLock.vue'),
  },
  {
    path: '/surelock/create',
    name: 'CreatePreservation',
    meta: {
      title: 'Portal - SureLock - Create Preservation',
    },
    beforeEnter: surelockCreateGuard,
    component: () =>
      import(/* webpackChunkName: "surelock" */ '../views/CreatePreservation.vue'),
  },
  {
    path: '/surelock/preservation/:preservationId',
    name: 'PreservationDetails',
    meta: {
      title: 'Portal - SureLock - Preservation Details',
    },
    beforeEnter: surelockGuard,
    component: () =>
      import(/* webpackChunkName: "surelock" */ '../views/SureLock/Preservation.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      title: 'Portal - Profile',
    },
    beforeEnter: authGuard,
    component: () =>
      import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
  },
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

router.onError((err) => {
  Vue.toasted.error(err.toString(), {
    position: 'top-left',
    duration: 3000,
  });
});

export default router;
